module.exports = __webpack_public_path__ + "static/img/2.5a9b2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/dreamworks/article/2.jpg
// module id = HaPn
// module chunks = 1